<template>
  <div>
    <div v-show="loading">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-show="!loading">
      <vx-card>
        <div>
          <vs-table
            :max-items="descriptionItems[1]"
            pagination
            :description="false"
            :data="taxList"
            search
            @selected="handleSelected"
            :description-items="descriptionItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.TaxMaster") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Tax' })"
                  size="small"
                  >{{ $t("setup.label.CreateTaxMaster") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.TaxCode") }}</vs-th>
              <vs-th>{{ $t("setup.label.GroupType") }}</vs-th>
              <vs-th>{{ $t("setup.label.GroupCode") }}</vs-th>
              <vs-th>{{ $t("setup.label.Type") }}</vs-th>
              <vs-th>{{ $t("setup.label.StartDate") }}</vs-th>
              <vs-th>{{ $t("setup.label.EndDate") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="index" :data="tax" v-for="(tax, index) in data">
                <vs-td :data="tax.taxCode">{{ tax.taxCode }}</vs-td>
                <vs-td :data="tax.groupType">{{ tax.groupType }}</vs-td>
                <vs-td :data="tax.groupCode">{{ tax.groupCode }}</vs-td>
                <vs-td :data="tax.type">{{ tax.type }}</vs-td>
                <vs-td :data="tax.startDate">{{
                  getDate(tax.startDate)
                }}</vs-td>
                <vs-td :data="tax.enddate">{{ getDate(tax.enddate) }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <div class="hidden-space">
                      <feather-icon
                        icon="PlusIcon"
                        :title="$t('setup.label.AddJurisdiction')"
                        svgClasses="w-5 h-5 text-danger stroke-current cursor"
                        @click="handleJurisdiction(tax.id)"
                        class="icon_row"
                      />
                    </div>
                    <div>
                      <feather-icon
                        icon="EditIcon"
                        :title="$t('setup.label.Edit')"
                        svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                        class="icon_row"
                        @click="editTax(tax.id)"
                      />
                    </div>
                    <div>
                      <feather-icon
                        icon="TrashIcon"
                        :title="$t('setup.label.Delete')"
                        svgClasses="w-5 h-5 text-danger stroke-current cursor"
                        @click="
                          editJobsPopup = true;
                          delId = tax.id;
                        "
                        class="icon_row"
                      />
                    </div>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <!-- <div class="centerx">
            <vs-popup
              class="popup-close"
              :title="$t('setup.label.DeleteTax')"
              :active.sync="editJobsPopup"
            >
              <form>
                <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                  <div class="vx-col sm:w-full w-full">
                    <div class="vx-col sm:w-full w-full">Are you sure?</div>
                  </div>
                </div>

                <div class="vx-row">
                  <span class="ml-4 mr-1">
                    <vs-button type="border" @click="editJobsPopup = false">{{
                      $t("setup.label.Cancel")
                    }}</vs-button>
                  </span>
                  <span class="ml-1 mr-2">
                    <vs-button @click="deleteTax(delId)" color="warning">{{
                      $t("setup.label.Ok")
                    }}</vs-button>
                  </span>
                </div>
              </form>
            </vs-popup>
          </div> -->
          <div class="centerx">
            <vs-popup
              class="popup-close"
              :title="
                $t('setup.label.Delete') +
                ' ' +
                $t('setup.label.Jurisdiction') +
                ' ' +
                $t('setup.label.Area')
              "
              :active.sync="deleteJurisdictionArea"
            >
              <form>
                <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                  <div class="vx-col sm:w-full w-full">
                    <div class="vx-col sm:w-full w-full">{{$t("setup.label.Are_you_sure_?")}}</div>
                  </div>
                </div>

                <div class="vx-row">
                  <span class="ml-4 mr-1">
                    <vs-button
                      type="border"
                      @click="deleteJurisdictionArea = false"
                      >{{ $t("setup.label.Cancel") }}</vs-button
                    >
                  </span>
                  <span class="ml-1 mr-2">
                    <vs-button
                      @click="removeJurisdiction(juryRegionPlace)"
                      color="warning"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </span>
                </div>
              </form>
            </vs-popup>
          </div>
          <div class="centerx">
            <vs-popup
              classContent="popup-example"
              :title="$t('setup.label.Jurisdiction')"
              :active.sync="jurisdictionPopup"
              class="popup-close jury-popup"
            >
              <ValidationObserver ref="observer">
                <form>
                  <div class="vx-row mb-4">
                    <div class="vx-col md:w-1/4 w-full">
                      <div class="dropdown-with-label">
                        <small class="date-label"
                          >{{ $t("setup.label.Jurisdiction")
                          }}<span class="required"> *</span></small
                        >
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.Jurisdiction')"
                        >
                          <v-select
                            v-if="extendedJurisdictionData"
                            label="mCodeValue"
                            :reduce="(obj) => obj.mCodeValue"
                            :options="extendedJurisdictionData"
                            v-model="jurisdiction"
                            :placeholder="$t('placeholder.label.SelectDate')"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            class="w-full"
                          >
                            <template v-slot:option="option">{{
                              option.mCodeValue
                            }}</template>
                          </v-select>
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="vx-col md:w-1/3 w-full"
                      v-if="
                        ['Country', 'State', 'District'].includes(jurisdiction)
                      "
                    >
                      <div class="dropdown-with-label">
                        <ValidationProvider
                          v-if="jurisdiction === 'Country'"
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.Country')"
                        >
                          <small class="date-label">
                            {{ jurisdiction }}<span class="required"> *</span>
                          </small>
                          <v-select
                            v-if="jurisdiction === 'Country'"
                            :label="`${jurisdiction.toLowerCase()}Name`"
                            :reduce="
                              (obj) => obj[`${jurisdiction.toLowerCase()}Name`]
                            "
                            :options="countryList"
                            v-model="country"
                            :placeholder="$t('placeholder.label.SelectDate')"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            class="w-full"
                          >
                            <template v-slot:option="option">{{
                              option[`${jurisdiction.toLowerCase()}Name`]
                            }}</template>
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </v-select>
                        </ValidationProvider>
                        <ValidationProvider
                          v-if="jurisdiction === 'State'"
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.State')"
                        >
                          <small class="date-label">
                            {{ jurisdiction }}<span class="required"> *</span>
                          </small>
                          <v-select
                            v-if="jurisdiction === 'State'"
                            :label="`${jurisdiction.toLowerCase()}Name`"
                            :reduce="
                              (obj) => obj[`${jurisdiction.toLowerCase()}Name`]
                            "
                            :options="stateList"
                            v-model="state"
                            :placeholder="$t('placeholder.label.SelectDate')"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            class="w-full"
                          >
                            <template v-slot:option="option">{{
                              option[`${jurisdiction.toLowerCase()}Name`]
                            }}</template>
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </v-select>
                        </ValidationProvider>
                        <ValidationProvider
                          v-if="jurisdiction === 'District'"
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.District')"
                        >
                          <small class="date-label">
                            {{ jurisdiction }}<span class="required"> *</span>
                          </small>
                          <v-select
                            v-if="jurisdiction === 'District'"
                            :label="`${jurisdiction.toLowerCase()}Name`"
                            :reduce="
                              (obj) => obj[`${jurisdiction.toLowerCase()}Name`]
                            "
                            :options="districtList"
                            v-model="district"
                            :placeholder="$t('placeholder.label.SelectDate')"
                            :dir="$vs.rtl ? 'rtl' : 'ltr'"
                            class="w-full"
                          >
                            <template v-slot:option="option">{{
                              option[`${jurisdiction.toLowerCase()}Name`]
                            }}</template>
                            <span class="validate-error" style="color: red">{{
                              errors[0]
                            }}</span>
                          </v-select>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="vx-col md:w-1/3 w-full"
                      v-if="
                        ['Country', 'State', 'District', 'Default'].includes(
                          jurisdiction
                        )
                      "
                    >
                      <div>
                        <ValidationProvider
                          rules="required"
                          v-slot="{ errors }"
                          :name="$t('setup.label.TaxType')"
                        >
                          <div class="dropdown-with-label">
                            <small class="date-label"
                              >{{ $t("setup.label.TaxType")
                              }}<span class="required"> *</span></small
                            >
                            <ValidationProvider
                              rules="required"
                              v-slot="{ errors }"
                              :name="$t('setup.label.RateType')"
                            >
                              <v-select
                                :options="rateTypes"
                                v-model="rateType"
                                :placeholder="$t('placeholder.label.SelectDate')"
                                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                                class="min-w-200 w-full"
                              >
                              </v-select>
                              <span class="validate-error" style="color: red">{{
                                errors[0]
                              }}</span>
                            </ValidationProvider>
                          </div>
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="vx-col md:w-1/4 w-full"
                      v-if="
                        ['Country', 'State', 'District', 'Default'].includes(
                          jurisdiction
                        )
                      "
                    >
                      <div>
                        <ValidationProvider
                          rules="required|numeric"
                          v-slot="{ errors }"
                          :name="$t('setup.label.TaxPercentage')"
                        >
                          <vs-input
                            :label="$t('setup.label.TaxPercentage')"
                            v-model="taxPercentage"
                            type="number"
                            class="w-full mb-2 starlabel"
                          />
                          <span class="validate-error" style="color: red">{{
                            errors[0]
                          }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                    <div
                      class="vx-col md:w-1/6 w-full"
                      v-if="
                        ['Country', 'State', 'District', 'Default'].includes(
                          jurisdiction
                        )
                      "
                    >
                      <div class="dropdown-with-label">
                        <span class="">
                          <vs-button
                            :disabled="disableAdd"
                            @click="addJurisdiction"
                            >{{ $t("setup.label.Add") }}</vs-button
                          >
                        </span>
                      </div>
                    </div>
                  </div>
                  <template v-if="jurisdictionRegion.length">
                    <div
                      class="vx-row mb-4"
                      v-for="(juryRegionPlace, index) in jurisdictionRegion"
                      :key="index"
                    >
                      <div class="vx-col md:w-2/5 w-full">
                        <vs-input
                          :label="$t('setup.label.Area')"
                          v-model="juryRegionPlace.name"
                          class="w-full mb-2 starlabel"
                          disabled
                        />
                      </div>
                      <div class="vx-col md:w-2/5 w-full">
                        <vs-input
                          :label="$t(`setup.label.TaxPercentage`)"
                          v-model="juryRegionPlace.rate"
                          class="w-full mb-2 starlabel"
                          disabled
                        />
                      </div>
                      <div class="vx-col md:w-1/5 w-full">
                        <div class="dropdown-with-label text-center pt-6">
                          <span class="ml-4 mr-1">
                            <feather-icon
                              icon="TrashIcon"
                              :title="$t('setup.label.Remove')"
                              svgClasses="w-5 h-5 text-danger stroke-current cursor"
                              @click="deleteArea(juryRegionPlace.id)"
                              class="icon_row"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div style="height: 40px"></div>
                </form>
              </ValidationObserver>
            </vs-popup>
          </div>
        </div>
      </vx-card>
    </div>
    <delete-popup
      :deletePopup="editJobsPopup"
      :title="$t('setup.label.TaxMaster')"
      @deletePressed="deleteTax(delId)"
      @cancelPressed="editJobsPopup = false"
    >
    </delete-popup>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { AtomSpinner } from "epic-spinners";
import { mapGetters, mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import moment from "moment";
export default {
  data() {
    return {
      loading: false,
      editJobsPopup: false,
      jurisdictionPopup: false,
      deleteJurisdictionArea: false,
      juryRegionPlace: "",
      jurisdiction: "",
      country: "",
      state: "",
      district: "",
      rateType: "",
      rateTypes: ["Percentage", "Flat"],
      taxPercentage: "",
      taxId: "",
      delId: 0,
      searchOption: 0,
      treeview: false,
      descriptionItems: [5, 10, 15],
    };
  },
  components: {
    "v-select": vSelect,
    AtomSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapGetters({ entities: "chargecode/getEntityList" }),
    ...mapState({
      taxList: (state) => state.taxmap.taxList,
      formattedDate: (state) => state.settings.selectedDateFormat,
      taxTemplate: (state) => state.taxmap.taxTemplate,
      addressData: (state) => state.addressMaster.addressData,
      jurisdictionRegion: (state) => state.taxmap.taxRegionList,
    }),
    countryList() {
      const uniqueData = {};
      this.addressData.forEach((item) => {
        if (!uniqueData[item.countryId]) {
          uniqueData[item.countryId] = {
            countryName: item.countryName,
            countryId: item.countryId,
          };
        }
      });
      return Object.values(uniqueData);
    },
    stateList() {
      const uniqueStates = {};
      this.addressData.forEach((item) => {
        if (item.stateId && !uniqueStates[item.stateId]) {
          uniqueStates[item.stateId] = {
            stateName: item.stateName,
            stateId: item.stateId,
            countryId: item.countryId,
          };
        }
      });
      return Object.values(uniqueStates);
    },
    districtList() {
      const uniqueDistricts = {};
      this.addressData.forEach((item) => {
        if (item.districtId && !uniqueDistricts[item.districtId]) {
          uniqueDistricts[item.districtId] = {
            districtName: item.districtName,
            districtId: item.districtId,
            stateId: item.stateId,
          };
        }
      });
      return Object.values(uniqueDistricts);
    },
    disableAdd() {
      return (
        (!this.country && !this.state && !this.district) ||
        !this.taxPercentage
      );
    },
    extendedJurisdictionData() {
      if (this.taxTemplate && this.taxTemplate.taxJurisdictionData) {
        return [
          ...this.taxTemplate.taxJurisdictionData,
          {
            id: -1,
            name: "Default",
            position: this.taxTemplate.taxJurisdictionData.length,
            active: true,
            mandatory: false,
            codeValue: "Default",
            mCodeValue: "Default",
            orderPossition: this.taxTemplate.taxJurisdictionData.length,
          },
        ];
      } else {
        return [];
      }
    },
  },
  methods: {
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    // isVisible(taxGroupCode){
    //   if (!taxGroupCode){
    //     return "hidePlusIcon"
    //   } else return "showplusIcon"
    // },
    deleteArea(id) {
      this.deleteJurisdictionArea = true;
      this.juryRegionPlace = id;
    },
    async handleJurisdiction(taxId) {
      this.taxId = taxId;
      try {
        await this.$store.dispatch("taxmap/getTaxRegionAction", this.taxId);
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
      this.jurisdiction = "";
      this.rateType = "";
      this.taxPercentage = "";
      this.$refs.observer.reset();
      this.jurisdictionPopup = true;
    },
    async addJurisdiction() {
      let payload = {
        taxId: this.taxId,
        name:
          this.jurisdiction === "Country"
            ? this.country
            : this.jurisdiction === "State"
            ? this.state
            : this.jurisdiction === "District"
            ? this.district
            : "Default",
        jurisdiction: this.jurisdiction,
        rateType: this.rateType,
        rate: this.taxPercentage,
        locale: "en_IN",
      };
      try {
        await this.$store.dispatch("taxmap/addJurisdictionAction", payload);
        await this.$store.dispatch("taxmap/getTaxRegionAction", this.taxId);
        this.jurisdictionPopup = false;
        this.$swal({
          title: "success",
          icon: "success",
          text: "Jurisdiction added Successfully!",
          type: "success",
        });
      } catch (err) {
        this.jurisdictionPopup = false;
        this.$toasted.error(err.message, {
          duration: 2000,
        });
      }
    },
    async removeJurisdiction(taxRegionId) {
      try {
        await this.$store.dispatch("taxmap/removeTaxRegionAction", taxRegionId);
        await this.$store.dispatch("taxmap/getTaxRegionAction", this.taxId);
        this.deleteJurisdictionArea = false;
        this.$toasted.error("Jurisdiction deleted Successfully!", {
          duration: 2000,
        });
      } catch (e) {
        this.deleteJurisdictionArea = false;
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    handleSelected() {
      // view tax
    },
    editTax(id) {
      this.$router.push({ name: "Edit Tax", params: { taxId: id } });
    },
    // deleteTax(id) {
    //   try {
    //     this.$store.dispatch("taxmap/deleteTax", id);
    //     this.editJobsPopup = false;
    //   } catch (e) {
    //     this.$toasted.error(e.message);
    //   }
    // },
    async deleteTax(id) {
      try {
        await this.$store.dispatch("taxmap/deleteTax", id);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Tax Master Deleted Successfully!",
          type: "success",
        });
        this.editJobsPopup = false;
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "error",
          text: error.message,
          type: "error",
        });
      }
    },
  },
  async mounted() {
    this.loading = true;
    try {
      await this.$store.dispatch("taxmap/fetchTaxList");
    } catch (e) {
      this.$toasted.error(e.message);
    }
    await this.$store.dispatch("taxmap/fetchTaxTemplate");
    await this.$store.dispatch("addressMaster/fetchAddressData");
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
.jury-popup ::v-deep .vs-popup {
  width: 800px;
}
.hidden-space {
  height: 17.25px;
  width: 23.75px;
}
</style>
